<template>
    <div class="container">
        <h1 class="title">Selecciona el perfil que necesitas <br>
            en 2 minutos</h1>
        <div class="circle-file">
            <div class="circles">
                <div class="circle"><v-icon name="bi-display" style="scale: 2; color: white;"></v-icon></div>
                <p class="text">Desarrollador<br> FrontEnd</p>
            </div>
            <div class="circles">
                <div class="circle-green"><v-icon name="hi-solid-database" style="scale: 2; color: white;"></v-icon></div>
                <p class="text">Desarrollador<br> BackEnd</p>
            </div>
            <div class="circles">
                <div class="circle"><v-icon name="gi-stack" style="scale: 2; color: white;"></v-icon></div>
                <p class="text">Desarrollador<br> FullStack</p>
            </div>
        </div>
        <div class="circle-file">
                <div class="circles">
                    <div class="circle-green"><v-icon name="fa-mobile-alt" style="scale: 2; color: white;"></v-icon></div>
                    <p class="text">Desarrollador<br> Móvil</p>
                </div>
            <div class="circles">
                <div class="circle"><v-icon name="gi-console-controller" style="scale: 2; color: white;"></v-icon></div>
                <p class="text">Desarrollador<br> Videojuegos</p>
            </div>
            <div class="circles">
                <div class="circle-green"><v-icon name="bi-diagram-3-fill" style="scale: 2; color: white;"></v-icon></div>
                <p class="text">Desarrollador<br> DevOps</p>
            </div>
        </div>
        <div class="circle-file">
            <div class="circles">
                <div class="circle"><v-icon name="md-security-sharp" style="scale: 2; color: white;"></v-icon></div>
                <p class="text">Desarrollador<br> Ciberseguridad</p>
            </div>
            <div class="circles">
                <div class="circle-green"><v-icon name="fa-robot" style="scale: 2; color: white;"></v-icon></div>
                <p class="text">Desarrollador<br> Machine Learning</p>
            </div>
        <div class="circles">
            <div class="circle"><v-icon name="md-science-outlined" style="scale: 2; color: white;"></v-icon></div>
            <p class="text">Científico<br> de Datos</p>
        </div>
    </div>
        <div class="circle-file">
            <div class="circles">
                <div class="circle-green"><v-icon name="si-blockchaindotcom" style="scale: 2; color: white;"></v-icon></div>
                <p class="text">Desarrollador<br> Blockchain</p>
            </div>
            <div class="circles">
                <div class="circle"><v-icon name="si-craftcms" style="scale: 2; color: white;"></v-icon></div>
                <p class="text">Desarrollador<br> CMS</p>
            </div>
            <div class="circles">
                <div class="circle-green"><v-icon name="io-add-circle" style="scale: 2; color: white;"></v-icon></div>
                <p class="text">Y Muchos<br>Más</p>
            </div>
        </div>
        <div class="spacer" style="width: 100%; height: 20px;"></div>
        <div class="nav-item">
            <a href="https://ademass-profile-request.netlify.app/" class="add-talent" target="_blank">
       Encuentra gratis talento en 2 minutos
      </a>
        </div>
    </div>
</template>

<script setup>
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    box-shadow: 20px 20px 20px rgba(0, 0, 0, 0.3);
    border: none;
    border-radius: 15px;
    margin-top: 50px;
    width: 70%;
    margin-left: 15%;
    padding: 15px;
    margin-bottom: 30px;
}
.add-talent{
    min-width: 350px;
}
@media screen and (max-width: 700px) {
    .container{
        width: 80%;
        margin-left: 0;
    }
    .add-talent {
    margin-bottom: 20px;
    min-width: 250px;
    margin-left: 0;
    text-align: center;
  }
}
.title {
    color: rgba(35, 35, 35, 1);
    width: 100%;
    font-size: 60px;
    font-style: Black;
    text-align: center;
    font-family: Darker Grotesque;
    font-weight: 900;

}

.circle {
    width: 70px;
    height: 70px;
    background-color: #2ea3f2;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.circle-green {
    width: 70px;
    height: 70px;
    background-color: #c4cf2c;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.circles {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    width: 200px;
}

.text {
    color: rgba(39, 52, 68, 1);
    font-size: 28px;
    font-style: Bold;
    text-align: center;
    font-family: Darker Grotesque;
    font-weight: 700;
    margin-top: 0;
}

.circle-file {
    display: flex;
    justify-content: space-around;
    width: 100%;
    flex-wrap: wrap;

}
.add-talent{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 13px;
    border-radius: 25px;
    color: white;
    background-color: rgba(196, 207, 44, 1);
    border: 2px solid rgba(196, 207, 44, 1);
    width: 300px;
    text-decoration: none;
    font-size: 24px;
    font-family: Darker Grotesque;
    font-weight: 600;
}
.add-talent:hover {
  background-color: white;
  color: rgba(196, 207, 44, 1);
  border: 2px solid rgba(196, 207, 44, 1);
}
.nav-item{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}
</style>